import { Component } from 'react'

import * as h from 'h'

import StandardContent from 'components/Popout/StandardContent'
import FacultyList from 'components/FacultyList'
import DownloadPrintablePDF from './DownloadPrintablePDF'

import styles from './styles.scss'

export default class IntellectualPropertyView extends Component {
  render () {
    const { element } = this.props
    const { name, image, descShort } = element

    return h.div(h.ca(styles.intellectualPropertyView),
      h.h(StandardContent, {
        title: name,
        preContent: h.h(IPPreContent, element),
        content: descShort,
        image: image.details
      }))
  }
}

class IPPreContent extends Component {
  render () {
    const { leadInventorName, caseManagerName, caseManagerEmail, faculties = [], pdfFile } = this.props
    const { issuedFilings, patentPendingFilings, provisionalFilings, nonprovisionalFilings } = this.props

    const numbers = [
      {
        name: 'Application Numbers',
        filings: [
          ...provisionalFilings,
          ...nonprovisionalFilings
        ]
      },
      { name: 'Publication Numbers', filings: patentPendingFilings },
      { name: 'Patent Numbers', filings: issuedFilings }
    ]

    return h.div(h.ca(styles.preContent),
      h.div(h.ca(styles.authorListAndDownload),
        faculties.length > 0 && h.h(FacultyList, { faculties }),
        pdfFile && h.div(h.ca(styles.downloadContainer),
          h.h(DownloadPrintablePDF, { href: pdfFile }))),
      h.dl(null,
        numbers
          .filter(x => x.filings.length)
          .map(({ name, filings }) => [
            h.dt({ key: 'term+' + name }, name),
            h.dd({ key: 'desc+' + name },
              ...joinAsArray(filings.map(filing =>
                h.h(IPPreContentPatentDisplay, { filing })), ', '))
          ])
          .reduce((acc, x) => [...acc, ...x], []),
        leadInventorName && h.dt(null, 'Lead Inventor'),
        leadInventorName && h.dd(null, leadInventorName),
        caseManagerName && h.dt(null, 'Case Manager'),
        caseManagerName && h.dd(null, caseManagerName),
        caseManagerEmail && h.dt(null, ''),
        caseManagerEmail && h.dd(h.ca(styles.email), caseManagerEmail)
      )
    )
  }
}

class IPPreContentPatentDisplay extends Component {
  render () {
    const { filing } = this.props
    const { num, date, url } = filing
    const nbsp = '\xa0'
    const text = [
      h.strong(null, num),
      (date ? [nbsp, '(', date, ')'] : []).join('')
    ]
    return url
      ? h.a({
        target: '_blank',
        href: url,
        rel: 'noreferrer noopener'
      }, ...text)
      : h.span(null, ...text)
  }
}

const joinAsArray = (arr, seperator) => {
  const result = []
  for (const [i, el] of arr.entries()) {
    result.push(el)
    if (i < (arr.length - 1)) {
      result.push(seperator)
    }
  }
  return result
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/IntellectualPropertyView/index.js